import { createSelector } from "reselect";

export const getDiscountCodes = createSelector(
	(state) => state.discountReducer,
	(detail) => detail.discountCodeRes
);